import { render, staticRenderFns } from "./template-work-order-build-task-edit-form.html?vue&type=template&id=6faa1a0e&scoped=true&"
import script from "./template-work-order-build-task-edit-form.ts?vue&type=script&lang=js&"
export * from "./template-work-order-build-task-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa1a0e",
  null
  
)

export default component.exports